import { SelectProps } from 'src/components/Select';
import { KeyValue } from 'src/types/generic';

export const keyValueToSelect = (keyValues: KeyValue[]): Required<SelectProps>['options'] =>
  keyValues.map(({ key, value }) => ({ label: key, value }));
